export const SET_BASE_DETAIL = "SET_BASE_DETAIL";
export const SET_SKU_PRICE = "SET_SKU_PRICE";
export const SET_SKU_SELECTOR_VISIBLE = "SET_SKU_SELECTOR_VISIBLE";
export const SET_CURRENT_SKU = "SET_CURRENT_SKU";
export const SET_SPU_SCORE = "SET_SPU_SCORE";
export const SET_FREIGHT_INFO = "SET_FREIGHT_INFO";
export const SET_DEFAULT_ADDRESS = "SET_DEFAULT_ADDRESS";
export const SET_IS_INIT_DEFAULT_ADDRESS = "SET_IS_INIT_DEFAULT_ADDRESS";
export const SET_SALE_STOCK_INFOS = "SET_SALE_STOCK_INFOS";
export const SET_INSTALLMENT_PLANS = "SET_INSTALLMENT_PLANS";
export const SET_PAGE_LOADING = "SET_PAGE_LOADING";
export const SET_IS_INIT_REPORT = "SET_IS_INIT_REPORT";
export const RESET_STATE = "RESET_STATE";
export const SET_DEEP_LINK = "SET_DEEP_LINK";
export const SET_SKU_ACTION = "SET_SKU_ACTION";
export const SET_OPEN_APP_LINK = "SET_OPEN_APP_LINK";
